import React, { useEffect } from "react";
import axiosInstance from "../../helpers/axios";
import { cancelAllAxiosRequests } from "../../helpers/cancelAxiosRequests";
import { clearCookies } from "../../helpers/auth";
import CircularProgress from '@mui/material/CircularProgress';
import AuthWrapper from './authWrapper';

const Logout = () => {

  useEffect(() => {
    cancelAllAxiosRequests();
    axiosInstance.get("/api/user/logout");
    clearCookies();
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
    
  }, []);

  return (
    <AuthWrapper style={{ width: '100%', height: '100vh' }}>
      <CircularProgress />
    </AuthWrapper>
  );
}

export default Logout;